/** CSS animation / gradient timing (matches Tailwind arbitrary duration classes in markup). */
export const TOOL_DISPLAY_SHIMMER_TEXT_DURATION_S = 2.4;
export const TOOL_CALL_WIDGET_ICON_SHIMMER_MS = 2800;
export const TOOL_CALL_WIDGET_FADE_OUT_MS = 200;
